import "./new-transaction-waiver.scss";

import { FormProvider } from "react-hook-form";
import { Button } from "primereact/button";

import { useNewTransactionWaiver } from "./new-transaction-waiver.hook";
import PrintWaiver from "../print-waiver/print-waiver";
import SignatureContent from "@shared/ui/signature-content/signature-content";
import { useTransactionStepContext } from "@domain/transaction/new-transaction/transaction-step.context";

export function NewTransactionWaiver() {
  const { previousStepper, signaturePreview, setSignaturePreview } =
    useTransactionStepContext();
  const {
    formMethod,
    printWaiverRef,
    selectedWaiver,
    handleSetSignature,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewTransactionWaiver();

  // LOCAL FUNCTION

  // RENDER
  const printWaiver = (
    <div style={{ display: "none" }}>
      <div ref={printWaiverRef}>
        {selectedWaiver ? (
          <PrintWaiver waiver={selectedWaiver} signature={signaturePreview} />
        ) : null}
      </div>
    </div>
  );

  return (
    <div id="NewTransactionWaiver" className="transaction-waiver">
      <div className="p-4">
        <FormProvider {...formMethod}>
          {printWaiver}
          <section className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-4">
            <div className="flex flex-col h-full">
              <span className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2">
                Waiver Preview
              </span>
              <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-inner flex-1 text-[11px]">
                {selectedWaiver ? (
                  <PrintWaiver waiver={selectedWaiver} signature={signaturePreview} isPreview={true} />
                ) : (
                  <div className="text-gray-400 flex items-center justify-center h-full min-h-[150px]">
                    Loading waiver content...
                  </div>
                )}
              </div>
            </div>
            <SignatureContent
              setSignature={(item) => handleSetSignature(item)}
              setPreviewSignature={(item) => setSignaturePreview(item)}
            />
          </section>
        </FormProvider>
      </div>

      <div className="flex pt-2 justify-between">
        <section className="flex gap-2">
          <Button
            label="Back"
            severity="secondary"
            icon="pi pi-arrow-left"
            onClick={() => previousStepper()}
          />
        </section>
        <Button
          label="Next"
          icon="pi pi-arrow-right"
          iconPos="right"
          onClick={handleSubmit(handleValidate, handleValidateError)}
        />
      </div>
    </div>
  );
}

export default NewTransactionWaiver;
